"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Focusable = _interopRequireDefault(require("@instructure/ui-focusable/lib/components/Focusable"));

var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));

var _LayoutPropTypes = _interopRequireDefault(require("@instructure/ui-layout/lib/utils/LayoutPropTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _ensureSingleChild = _interopRequireDefault(require("@instructure/ui-utils/lib/react/ensureSingleChild"));

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _uid = _interopRequireDefault(require("@instructure/uid"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _Popover = _interopRequireWildcard(require("../Popover"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _dec3, _class, _class2, _temp;

var styles = {
  componentId: 'cxCug',
  template: function template(theme) {
    return "\n\n.cxCug_bGBk{box-sizing:border-box;display:block;font-family:".concat(theme.fontFamily || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', "}\n\n.cxCug_doqw{font-size:").concat(theme.smallFontSize || 'inherit', ";padding:").concat(theme.smallPadding || 'inherit', "}\n\n.cxCug_ycrn{font-size:").concat(theme.mediumFontSize || 'inherit', ";padding:").concat(theme.mediumPadding || 'inherit', "}\n\n.cxCug_cMDj{font-size:").concat(theme.largeFontSize || 'inherit', ";padding:").concat(theme.largePadding || 'inherit', "}");
  },
  'root': 'cxCug_bGBk',
  'small': 'cxCug_doqw',
  'medium': 'cxCug_ycrn',
  'large': 'cxCug_cMDj'
};
var Tooltip = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _deprecated.default)('5.42', {
  size: true
}), _dec3 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this));
    _this._id = (0, _uid.default)('Tooltip');
    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "renderTrigger",
    value: function renderTrigger(focused) {
      var _this$props = this.props,
          children = _this$props.children,
          as = _this$props.as;
      var triggerProps = {
        'aria-describedby': this._id
      };

      if (as) {
        var Trigger = (0, _getElementType.default)(Tooltip, this.props);
        var props = (0, _passthroughProps.omitProps)(this.props, Tooltip.propTypes);
        return _react.default.createElement(Trigger, Object.assign({}, props, triggerProps), children);
      } else if (typeof children === 'function') {
        return children({
          focused: focused,
          getTriggerProps: function getTriggerProps(props) {
            return (0, _objectSpread2.default)({}, triggerProps, props);
          }
        });
      } else {
        return (0, _ensureSingleChild.default)(this.props.children, triggerProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var size = this.props.size || 'small';
      return _react.default.createElement(_Focusable.default, {
        render: function render(_ref) {
          var _classnames;

          var focused = _ref.focused;
          return _react.default.createElement(_Popover.default, {
            on: _this2.props.on,
            shouldRenderOffscreen: true,
            shouldReturnFocus: false,
            placement: _this2.props.placement,
            variant: _this2.props.variant,
            mountNode: _this2.props.mountNode,
            constrain: _this2.props.constrain,
            shadow: "none"
          }, _react.default.createElement(_Popover.PopoverTrigger, null, _this2.renderTrigger(focused)), _react.default.createElement(_Popover.PopoverContent, null, _react.default.createElement("span", {
            id: _this2._id,
            className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles[size], size), _classnames)),
            role: "tooltip"
          }, _this2.props.tip)));
        }
      });
    }
  }]);
  Tooltip.displayName = "Tooltip";
  return Tooltip;
}(_react.Component), _class2.propTypes = {
  /**
  * @param {Object} renderProps
  * @param {Boolean} renderProps.focused - Is the Tooltip trigger focused?
  * @param {Function} renderProps.getTriggerProps - Props to be spread onto the trigger element
  */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  tip: _propTypes.default.node.isRequired,

  /**
  * the element type to render as (assumes a single child if 'as' is undefined)
  */
  as: _propTypes.default.elementType,
  // eslint-disable-line react/require-default-props

  /**
   * The action that causes the Content to display (`click`, `hover`, `focus`)
   */
  on: _propTypes.default.oneOfType([_propTypes.default.oneOf(['click', 'hover', 'focus']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['click', 'hover', 'focus']))]),
  variant: _propTypes.default.oneOf(['default', 'inverse']),
  placement: _LayoutPropTypes.default.placement,

  /**
  * __DEPRECATED 5.42__  `size` is now deprecated
  */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  // eslint-disable-line react/require-default-props

  /**
   * An element or a function returning an element to use as the mount node
   * for the `<Tooltip />` (defaults to `document.body`)
   */
  mountNode: _LayoutPropTypes.default.mountNode,

  /**
   * The parent in which to constrain the tooltip.
   * One of: 'window', 'scroll-parent', 'parent', 'none', an element,
   * or a function returning an element
   */
  constrain: _LayoutPropTypes.default.constrain
}, _class2.defaultProps = {
  on: void 0,
  variant: 'default',
  placement: 'top',
  mountNode: null,
  constrain: 'window'
}, _temp)) || _class) || _class) || _class);
exports.default = Tooltip;